module.exports = __webpack_public_path__ + "static/Artboard-14-fbb81accb225a7473b8adc1024d572d9.png";